import { Field, Form, Formik } from 'formik';
import { method } from 'lodash';
import React, { lazy, Suspense, useState, useTransition, useEffect } from 'react';
import ImageLoader from '../common/image-loader';
import * as Yup from 'yup'
import { config } from '../common/constant';
import Footer from '../section/footer/footer';
import { useSelector, useDispatch } from 'react-redux';
import { MANUAL_ICON, SINGPASS_ICON } from '../common/images-s3';
import * as userAction from '../redux/actions/userAction';


export const ManualEnrollmentHeader = {
    title: 'Manual Enrolment',
    subTitle: 'Next - Payment Method',
    steps: 6
}

export const CorporateEnrollmentHeader = {
    title: 'Corporate Enrolment',
    subTitle: 'Next - Payment Method',
    steps: 6
}

export const SkipEnrollmentHeader =
{
    title: 'Payer Contact Details',
    subTitle: 'Next - Payment Method',
    steps: 6
}


// will create anum for all method id


const EnrollmentMethod = ({ setHeaderData }) => {

    const user = useSelector((state) => state.userReducer)
    // user.userData.flow
    const dispatch = useDispatch()
    const isBussiness = user.isBusinessPayer

    const [selectedMethod, setSelectedMethod] = useState({
        id: null,
        label: "",
        value: "",
        iconUrl: "",
    })

    const [nric, setNric] = useState(user.isSearchByNricValue ?? '')
    const [nricValidation, setNricValidation] = useState({
        invalid: false,
        msg: ''
    })

    const IndividualOptions = [
        {
            id: 1,
            label: "Singpass",
            value: "singpass",
            iconUrl: SINGPASS_ICON,
        },
        {
            id: 2,
            label: "Manual",
            value: "manual",
            iconUrl: MANUAL_ICON,
        },
        {
            id: 3,
            label: "NRIC/FIN <span> (For Existing Payers only) </span>",
            value: "nric",
            placeholder: "Enter NRIC or FIN",
        },
    ]
    const CorporateOptions = [
        {
            id: 2,
            label: "Manual",
            value: "manual",
            iconUrl: MANUAL_ICON,
        },
        {
            id: 3,
            label: "UEN <span> (For Existing Payers only) </span>",
            value: "nric",
            placeholder: "Enter UEN",
        },
    ]
    const options = user.isBusinessPayer ? CorporateOptions : IndividualOptions

    const handleNric = (value) => {
        const trimmedValue = String(value).trim().toUpperCase();
        setNric(trimmedValue);


    };

    const validateNRIC = (value) => {
        const trimmedValue = String(value).trim().toUpperCase();
        const isBusinessCase = isBussiness;
        console.log(isBusinessCase, 'cased', value);
    
        const emptyMsg = `Please enter ${isBusinessCase ? 'UEN' : 'NRIC'}`;
        const invalidMsg = isBusinessCase ? 'Invalid UEN Number' : 'Please enter a correct NRIC';
        const lengthMsg = isBusinessCase ? 'Please enter valid UEN number' : invalidMsg;
        const regex = isBusinessCase ? config.REGEX.UEN : config.REGEX.NRIC;
    
        console.log(regex.test(trimmedValue), 'regex.test(trimmedValue)');
    
        if (trimmedValue) {
            if (isBusinessCase && (trimmedValue.length < 9 || trimmedValue.length > 10)) {
                setNricValidation({ invalid: true, msg: lengthMsg });
            } else if (regex.test(trimmedValue)) {
                setNricValidation({ invalid: false, msg: '' });
            } else {
                setNricValidation({ invalid: true, msg: invalidMsg });
            }
        } else if (selectedMethod.id === 3) {
            setNricValidation({ invalid: true, msg: isBusinessCase ? 'Please enter UEN' : emptyMsg });
        } else {
            setNricValidation({ invalid: false, msg: '' });
        }
    };


    const handleMethodSelection = (value) => {
        if (value.id == 1) {
            dispatch(userAction.resetFormExceptOnbehafl())
        }
        if (value.id !== 3) {
            setNricValidation({
                invalid: false,
                msg: ''
            })
        }
        setSelectedMethod(value)
    }

    const handleNext = () => {
        if (selectedMethod.id === 1) {
            const flow = {
                flow: config.FLOW.SINGPASS,
            };
            dispatch(userAction.updateUserSteps(SkipEnrollmentHeader))
            setHeaderData(SkipEnrollmentHeader)
            dispatch(userAction.updateUserData({ ...user.userData, ...flow }))
        }
        else if (selectedMethod.id === 2) {
            const flow = {
                flow: config.FLOW.MANUALLY,
            };
            dispatch(userAction.updateUserSteps(user.isBusinessPayer ? CorporateEnrollmentHeader : ManualEnrollmentHeader))
            setHeaderData(user.isBusinessPayer ? CorporateEnrollmentHeader : ManualEnrollmentHeader)
            dispatch(userAction.updateUserData({ ...user.userData, ...flow }))

        }
        else if (selectedMethod.id === 3) {
            dispatch(userAction.updatePaymentData({
                isSearchByNric: true,
            }));
            dispatch(userAction.resetFormExceptOnbehafl())
            dispatch(userAction.updateUserSteps(SkipEnrollmentHeader))
            setHeaderData(SkipEnrollmentHeader)
            dispatch(userAction.updateUserData({ nric }))
        }
    }

    useEffect(() => {
        if (user.isBusinessPayer) {
            if (user.isSearchByNric) {
                setSelectedMethod(CorporateOptions[1])
            }
            else {
                setSelectedMethod(CorporateOptions[0])
            }
        }
        else {
            if (user?.userData?.flow === config.FLOW.MANUALLY) {
                setSelectedMethod(IndividualOptions[1])
            }
            else if (user?.userData?.flow === config.FLOW.SINGPASS) {
                setSelectedMethod(IndividualOptions[0])
            }
            else if (user.isSearchByNric) {
                setSelectedMethod(IndividualOptions[2])
            }
        }
    }, [])

    //reset isSearchByNric
    useEffect(() => {
        if (user.isSearchByNric) {
            dispatch(userAction.updatePaymentData({
                isSearchByNric: false,
            }));
        }
    }, [user.isSearchByNric]);

    const handleSkip = () => {
        const flow = {
            flow: config.FLOW.ANONYMOUS,
        };
        dispatch(userAction.resetFormExceptOnbehafl())
        dispatch(userAction.updateUserData({ ...flow }))
        dispatch(userAction.updateUserSteps(SkipEnrollmentHeader))
        setHeaderData(SkipEnrollmentHeader)

    }
    return (
        <>
            <div className='flow-view'>
                <div className='cards-block enrollment-method-pg'>
                    {
                        options.map((value, index) => {
                            if (value.id !== 3) {
                                return (
                                    <>
                                        <div key={index} className={`common-card card-center  ${selectedMethod.id === value.id ? 'active' : ''}`} onClick={() => handleMethodSelection(value)}>
                                            <div className='card-left'>
                                                <div className='card-icon'>
                                                    <ImageLoader type="image" src={value.iconUrl}> </ImageLoader>
                                                </div>
                                                <div className='card-content'>
                                                    <h4>{value.label}</h4>
                                                </div>
                                            </div>
                                            <div className='card-right custom-radio'>
                                                <input type="radio" id={value.id} defaultChecked={selectedMethod.id === value.id} checked={selectedMethod.id === value.id} />
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                            else {
                                return (
                                    <>
                                        <div key={index} className={`common-card card-with-input card-center ${selectedMethod.id === value.id ? 'active' : ''}`} onClick={() => handleMethodSelection(value)}>
                                            <div className='card-left'>

                                                <label dangerouslySetInnerHTML={{ __html: value.label }} />

                                                {/* <label> {value.label}</label> */}
                                                <input type='text' placeholder={value.placeholder} value={nric} 
                                                // onChange={(e) => handleNric(e.target.value.trim().toUpperCase())} 
                                                onChange={(e) => {
                                                    const trimmedValue = e.target.value.trim().toUpperCase();
                                                    handleNric(trimmedValue);
                                                    validateNRIC(trimmedValue);
                                                    dispatch(userAction.updateSearchByNric(trimmedValue))
                                                  }}
                                                onBlur={(e) => validateNRIC(e.target.value.trim().toUpperCase())} />
                                                {
                                                    nricValidation.invalid &&
                                                    <span className='error'> {nricValidation.msg}</span>
                                                }
                                            </div>
                                            <div className='card-right custom-radio'>
                                                <input type="radio" id={value.id} defaultChecked={selectedMethod.id === value.id} checked={selectedMethod.id === value.id} />
                                            </div>
                                        </div>
                                    </>
                                )
                            }
                        })
                    }

                </div>
            </div>

            <Footer isSkipButtonVisible={(!user.hasIRASInclusion) && (!user.isBusinessPayer)} handleNext={handleNext} handleSkip={handleSkip} disabled={((!selectedMethod.id) || nricValidation.invalid) || ((selectedMethod.id === 3) && !nric)} />

        </>
    )

}

export default EnrollmentMethod

